import { ScreenHeader } from 'components'
import React, { useState } from 'react'
import { CreatorTabs } from 'utility'
import { HeaderWrapper } from './dashboard'
import { Tabs } from 'antd'
import { BlockedCreatorsScreen, AllCreatorsScreen } from 'page-components'

export const CreatorsScreen = () => {
  const [tab, setTab] = useState(CreatorTabs.UnBlocked)

  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="List of Creators" />
      </HeaderWrapper>
      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey={CreatorTabs.UnBlocked}
            activeKey={tab}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
            items={[
              {
                key: CreatorTabs.UnBlocked,
                label: 'Creators',
                children: tab === CreatorTabs.UnBlocked ? <AllCreatorsScreen /> : null,
              },
              {
                key: CreatorTabs.Blocked,
                label: 'Blocked Creators',
                children: tab === CreatorTabs.Blocked ? <BlockedCreatorsScreen /> : null,
              },
            ]}
          />
        </div>
      </div>
    </div>
  )
}
